import CreateMarksCommand from "./CreateMarksCommand";
import MarksEditing from "./MarksEditing";
import HighlightUI from "./HighlightUI";

import { Plugin } from "@ckeditor/ckeditor5-core";

export default class Marks extends Plugin {
  init() {
    const editor = this.editor;
  }

  static get pluginName() {
    return "cdeMarks";
  }

  static get requires() {
    return [CreateMarksCommand, HighlightUI, MarksEditing];
  }
}
